import { render, staticRenderFns } from "./RegionTable.vue?vue&type=template&id=692b28c5&"
import script from "./RegionTable.vue?vue&type=script&lang=js&"
export * from "./RegionTable.vue?vue&type=script&lang=js&"
import style0 from "./RegionTable.vue?vue&type=style&index=0&id=692b28c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports